import { ModifierLocalisationMetier } from '../../editMachine/modifierLocalisationMetier';
import controlesIcon from '../../../../images/controlesSideBarIcon.svg';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import { ModifierStatut } from '../../editMachine/modifierStatut';
import metierIcon from '../../../../images/metierSideBarIcon.svg';
import polesIcon from '../../../../images/polesSideBarIcon.svg';
import sitesIcon from '../../../../images/sitesSideBarIcon.svg';
import { FormatDate } from '../../../../utils/formatDate';
import calender from '../../../../images/calender.svg';
import MachineStatus from '../../machineStatus';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iconify from '../../../Iconify';
import { useState } from 'react';
import '../../../../css/machines/localisationEtStatut.css';

const LocalisationEtStatut = () => {

    const { t } = useTranslation();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasMachineUpdatePermission = useHasPermission('machine_update');

    const [modifyStatut, setModifyStatut] = useState(false);
    const [modifyLocalisationMetier, setModifyLocalisationMetier] = useState(false);

    return (
        <Box className='localisationEtStatut_main_box'>
            <Box className='localisationEtStatut_box'>
                <Box className='localisation_edit_box'>
                    <Typography className='localisationEtStatut_title'>{t('Localisation et rattachement')}</Typography>
                    {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='localisationEtStatut_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyLocalisationMetier(true)} />}
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"oui:vis-map-region"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>{t('Region :')}</Typography>
                        {machineDetailsData?.region?.name ?
                            <Typography className='localisationEtStatut_text_localisation'>{machineDetailsData?.region?.name}</Typography>
                            :
                            <Typography className='localisationEtStatut_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <img src={sitesIcon} alt="icon" loading='lazy' decoding='async' />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>{t('Site :')}</Typography>
                        {machineDetailsData?.site?.name ?
                            <Typography className='localisationEtStatut_text_localisation'>{machineDetailsData?.site?.name}</Typography>
                            :
                            <Typography className='localisationEtStatut_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <img src={polesIcon} alt="icon" loading='lazy' decoding='async' />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>{t('Pole :')}</Typography>
                        {machineDetailsData?.pole?.name ?
                            <Typography className='localisationEtStatut_text_localisation'>{machineDetailsData?.pole?.name}</Typography>
                            :
                            <Typography className='localisationEtStatut_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Box className='localisationEtStatut_icon_title_box'>
                        <img src={metierIcon} alt="icon" loading='lazy' decoding='async' />
                        <Typography className='localisationEtStatut_text'>{t('Métiers :')}</Typography>
                    </Box>

                    <Box className='localisationEtStatut_response_box'>

                        {machineDetailsData?.machine_metier?.length > 0 ?
                            <Box className='localisationEtStatut_text_metier_array'>
                                {machineDetailsData?.machine_metier?.map(metier =>
                                    <Typography className='localisationEtStatut_text_metier'>{metier?.metier?.name}</Typography>
                                )}
                            </Box>
                            :
                            <Typography className='localisationEtStatut_text'>--</Typography>
                        }
                    </Box>
                </Box>
            </Box>
            <Box className='localisationEtStatut_box'>
                <Box className='localisation_edit_box'>
                    <Typography className='localisationEtStatut_title'>{t('Contrôle Sécurité')}</Typography>
                    {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='localisationEtStatut_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyStatut(true)} />}
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <img src={controlesIcon} alt="icon" loading='lazy' decoding='async' />
                    <Typography className='localisationEtStatut_text'>
                        {t('Statut contrôle :')} {machineDetailsData?.status ? <MachineStatus status={machineDetailsData?.status} /> : '--'}
                    </Typography>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <img src={calender} alt="icon" style={{ width: '30px', height: '25px', padding: '3px' }} loading='lazy' decoding='async' />
                    <Typography className='localisationEtStatut_text'>
                        {t('Date contrôle :')} {FormatDate(machineDetailsData?.machine_control[0]?.control_date) ? <Typography className='localisationEtStatut_text_statut_controle'>{FormatDate(machineDetailsData?.machine_control[0].control_date)}</Typography> : '--'}
                    </Typography>
                </Box>
            </Box>
            {modifyStatut &&
                <ModifierStatut
                    modifyStatut={modifyStatut}
                    setModifyStatut={setModifyStatut}
                />
            }
            {modifyLocalisationMetier &&
                <ModifierLocalisationMetier
                    modifyLocalisationMetier={modifyLocalisationMetier}
                    setModifyLocalisationMetier={setModifyLocalisationMetier}
                />
            }
        </Box>
    );
}

export default LocalisationEtStatut;